'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const NewsletterSignup: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setEmail('');
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <div className="bg-desert-gradient rounded-lg p-8 shadow-brand-elevated">
      <div className="flex items-start mb-4">
        <Icon name="EnvelopeIcon" size={32} className="text-white mr-4 flex-shrink-0" variant="solid" />
        <div>
          <h3 className="font-headline font-bold text-2xl text-white mb-2">
            Stay Updated
          </h3>
          <p className="font-body text-white/90">
            Get seasonal cleaning tips and exclusive offers delivered to your inbox.
          </p>
        </div>
      </div>

      {isSubmitted ? (
        <div className="bg-white/20 rounded-lg p-4 flex items-center">
          <Icon name="CheckCircleIcon" size={24} className="text-white mr-3" variant="solid" />
          <span className="font-body text-white font-medium">
            Thanks for subscribing! Check your email for confirmation.
          </span>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            required
            className="flex-1 px-4 py-3 rounded-lg font-body text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-white"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-white text-primary font-body font-semibold rounded-lg hover:bg-white/90 transition-brand shadow-brand flex items-center justify-center whitespace-nowrap"
          >
            Subscribe
            <Icon name="ArrowRightIcon" size={18} className="ml-2" />
          </button>
        </form>
      )}
    </div>
  );
};

export default NewsletterSignup;